import { InvoiceStatus } from "@api/graphql/generated/generated-types";

export function formatInvoiceStatus(status: InvoiceStatus): string {
  switch (status) {
    case InvoiceStatus.ToReview:
      return "To Review";
    case InvoiceStatus.Approved:
      return "Approved";
    case InvoiceStatus.Voided:
      return "Voided";
  }
}
